export default __webpack_public_path__ + "static/media/Macrobac-15-ml-eng.1b52f98e.jpg";